import "./servicenowDeveloperTraining.scss";
import "../../utilities/script/header";
import "../../utilities/script/footer";
import "../../utilities/script/upcomingBatches";
import "../../utilities/script/downloadBrochure";
import "./../../utilities/script/requestCallBack";
import "../../utilities/script/reachUsOutForm";
import "../../utilities/script/reviews";
import "../../utilities/script/testimonial";
import "../../utilities/script/salesforceInsights";
import "../../utilities/script/downloadCoursePlan";
import "../../utilities/script/downloadExamGuide";
import "./../../utilities/script/projectPopUp";

import Form from "../../utilities/script/form";
import Swal from "sweetalert2";
import Swiper from "swiper";
import { Navigation, Autoplay } from "swiper/modules";
import { gsap } from "gsap";
import { ScrollTrigger } from "gsap/ScrollTrigger";
import { MotionPathPlugin } from "gsap/MotionPathPlugin";
import { ScrollToPlugin } from "gsap/all";

gsap.registerPlugin(ScrollToPlugin);
gsap.registerPlugin(ScrollTrigger, MotionPathPlugin);

document.querySelectorAll(".statis").forEach(function (element) {
  var countTo = parseInt(element.getAttribute("data-stats"));
  var countNum = parseInt(element.textContent);
  var duration = 3000;
  var startTime = null;
  function animate(timestamp) {
    if (!startTime) startTime = timestamp;
    var progress = timestamp - startTime;
    var increment = (countTo / duration) * progress;
    if (progress < duration) {
      element.textContent = Math.floor(countNum + increment);
      requestAnimationFrame(animate);
    } else {
      element.textContent = countTo;
    }
  }
  requestAnimationFrame(animate);
});

var swiper = new Swiper(".swiper-logos", {
  slidesPerView: 8,
  spaceBetween: 0,
  centeredSlides: true,
  modules: [Autoplay],
  speed: 1500,
  autoplay: {
    delay: 0,
  },
  loop: true,
  slidesPerView: "auto",
  allowTouchMove: false,
  disableOnInteraction: true,
});

document.querySelector("#enroll-now").addEventListener("click", () => {
  gsap.to(window, {
    duration: 0,
    scrollTo: { y: "#upcoming-batches", offsetY: 135 },
  });
});

const arrow = document.querySelectorAll(".course-toggle-arrow");
document.querySelectorAll(".course-toggle").forEach((toggle) => {
  toggle.addEventListener("click", () => {
    const courseList = toggle.nextElementSibling;
    toggle.children[0].classList.toggle("rotate-arrow");
    courseList.classList.toggle("open");
  });
});

const animationPath = gsap
  .timeline({
    scrollTrigger: {
      trigger: ".svg-container",
      scrub: true,
      start: "top center-=10%",
      end: "bottom top",
    },
  })
  .to("#arrow", { display: "block" })
  .fromTo(
    "#path",
    { strokeDasharray: "0, 3705" },
    { strokeDasharray: "3705, 0", duration: 6 },
    0,
  )
  .to(
    "#arrow",
    {
      motionPath: {
        path: "#path",
        align: "#path",
        alignOrigin: [0.5, 0.5],
        autoRotate: -90,
      },
      duration: 6,
    },
    0,
  );

gsap.registerPlugin(ScrollTrigger, ScrollToPlugin);
const navLinks = document.querySelectorAll(".nav-link");
navLinks.forEach((link) => {
  link.addEventListener("click", (e) => {
    e.preventDefault();
    const targetId = link.getAttribute("href");
    gsap.to(window, {
      scrollTo: {
        y: targetId,
        offsetY: () => (window.innerWidth > 580 ? 180 : 350),
      },
    });
  });
});

var sections = [];
sections.push(document.getElementById("plans"));
sections.push(document.getElementById("curriculum"));
sections.push(document.getElementById("upcoming-batches"));
sections.push(document.getElementById("faqs"));
var buttons = document.querySelectorAll(".nav-link");
const nav = document.getElementById("sticky-nav");
const dropdownHeading = document.querySelector(".dropdown-heading");
const dropdownHeadingContent = document.querySelector(
  ".dropdown-heading-content",
);

if (window.innerWidth > 580) {
  nav.classList.remove("activeDropDown");
  dropdownHeading.classList.add("none");
  sections.forEach((panel, i) => {
    ScrollTrigger.create({
      trigger: panel,
      start: "top 220px",
      end: "+=" + panel.clientHeight,
      onEnter: () => {
        buttons.forEach((e) => {
          e.classList.remove("activeNav");
        });
        buttons[i + 1].classList.add("activeNav");
      },
      onEnterBack: () => {
        buttons.forEach((e) => {
          e.classList.remove("activeNav");
        });
        buttons[i + 1].classList.add("activeNav");
      },
    });
  });
}

if (window.innerWidth < 580) {
  dropdownHeading.classList.remove("none");
  dropdownHeadingContent.innerHTML = buttons[1].innerHTML;
  buttons[1].classList.add("none");
  nav.classList.add("activeDropDown");
  sections.forEach((panel, i) => {
    ScrollTrigger.create({
      trigger: panel,
      start: "top center",
      end: "+=" + panel.clientHeight,
      onEnter: () => {
        dropdownHeadingContent.innerHTML = buttons[i + 1].innerHTML;
        buttons.forEach((button) => {
          button.classList.remove("none");
        });
        buttons[i + 1].classList.add("none");
      },
      onEnterBack: () => {
        dropdownHeadingContent.innerHTML = buttons[i + 1].innerHTML;
        buttons.forEach((button) => {
          button.classList.remove("none");
        });
        buttons[i + 1].classList.add("none");
      },
    });
  });
  buttons.forEach((button) => {
    button.addEventListener("click", (e) => {
      e.preventDefault();
      nav.classList.toggle("openDropDown");
      if (!e.target.classList.contains("dropdown-heading")) {
        dropdownHeadingContent.innerHTML = e.target.innerHTML;
        buttons.forEach((button) => {
          button.classList.remove("none");
        });
        e.target.classList.add("none");
      }
    });
  });
}

let all_icons = document.getElementsByClassName("iconsign");
function changeSign(inde) {
  if (all_icons[inde].innerText == "+") all_icons[inde].innerText = "-";
  else all_icons[inde].innerText = "+";
}

const BindEvent = () => {
  let faq_question = document.getElementsByClassName("faq-question");
  let hiddenFaqs = document.querySelectorAll(".hidden-faq");
  let viewAllFaqBtn = document.querySelector(".faq-view-btn");

  for (let i = 0; i < faq_question.length; i++) {
    const question = faq_question[i];
    question.addEventListener("click", function (e) {
      let all_faq = document.getElementsByClassName("faq");
      let isopen = e.currentTarget.parentNode.classList.contains("active");
      for (let index = 0; index < all_faq.length; index++) {
        all_faq[index].classList.remove("active");
      }
      if (isopen == false) {
        e.currentTarget.parentNode.classList.add("active");
      }
    });
  }
  viewAllFaqBtn.addEventListener("click", () => {
    if (!viewAllFaqBtn.classList.contains("active")) {
      viewAllFaqBtn.textContent = "View Less";
      viewAllFaqBtn.classList.add("active");
      hiddenFaqs.forEach((hiddenFaq) => {
        hiddenFaq.style.display = "flex";
      });
    } else {
      viewAllFaqBtn.textContent = "View All";
      viewAllFaqBtn.classList.remove("active");
      hiddenFaqs.forEach((hiddenFaq) => {
        hiddenFaq.style.display = "none";
      });
    }
  });
};

BindEvent();

let all_faq_ = document.getElementsByClassName("faq-question");
for (let index = 0; index < all_icons.length; index++) {
  all_faq_[index].addEventListener("click", function (e) {
    changeSign(index);
    for (let inde = 0; inde < all_icons.length; inde++) {
      if (inde != index) {
        all_icons[inde].innerText = "+";
      }
    }
  });
}

// ServiceNow Webinar
if (window.location.href.indexOf("#ServiceNow-webinar") != -1) {
  gsap.to(window, {
    duration: 1.5,
    scrollTo: { y: "#servicenow-webinar", offsetY: 200 },
  });
}

const joinServicenowWebinar = new Form(
  document.querySelector("#join-servicenow-webinar"),
);

Array.from(
  document.querySelectorAll(
    'button[data-open-modal="join-servicenow-webinar"]',
  ),
).forEach((btn) => {
  btn.addEventListener("click", (event) => {
    const dataset = event.currentTarget.dataset;
    joinServicenowWebinar.modal.querySelector("input[name=lsource]").value =
      dataset.lsource;
  });
});

joinServicenowWebinar.validate.onSuccess(async (event) => {
  try {
    const formData = new FormData(event.target);
    formData.append("website-link", window.location.href);

    joinServicenowWebinar.modal.classList.add("loading");

    let response = await fetch("/wp-content/themes/s2-labs/student-form.php", {
      body: formData,
      method: "POST",
    });

    if (!response.ok) throw Error("Something Went Wrong");

    let textData = await response.text();
    if (textData.indexOf("Technical Error") > 0) {
      Swal.fire({
        title: "Error!",
        text: "Something went wrong! Please try again after sometime...",
        icon: "error",
        confirmButtonText: "Close",
      });
      window.location.href =
        window.location.href + "?cachebuster=" + new Date().getTime();
      return false;
    }

    fbq("track", "CompleteRegistration");
    Swal.fire({
      title: "Thank you!",
      text: "You will receive email shortly.",
      icon: "success",
      confirmButtonText: "Close",
    });
  } catch {
    Swal.fire({
      title: "Error!",
      text: "Something went wrong! Please try again after sometime...",
      icon: "error",
      confirmButtonText: "Close",
    });
  } finally {
    joinServicenowWebinar.modal.classList.remove("loading");
    joinServicenowWebinar.modal.querySelector("form").reset();
    joinServicenowWebinar.toggleModal();
  }
});

let webinarScroll = document.querySelector(".webinar-scroll-btn");
webinarScroll.addEventListener("click", () => {
  gsap.to(window, {
    duration: 1.5,
    scrollTo: { y: "#servicenow-webinar", offsetY: 200 },
  });
});
